module.exports = __webpack_public_path__ + "static/wpack/extracted/dual-ring-spinnered0c3c9e860f7efc6a80b54b113bdb09.svg";